import styled, { css } from 'styled-components'

const designerCSS = css`
  .user_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 1;
  }
  .user_tabs_wrapper .user_panels {
    width: 100%;
  }
  .sections_wrapper .user_tabs_panel {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
  }
  .user_tabs_panel .content.column {
    width: 100%;
    align-items: center;
    padding: 30px 0 0 0;
    border-top: 0;
  }

  .user_tabs_panel .content.column:first-child {
    width: 60%;
    padding: 20px 60px 10px 30px;
  }

  .user_tabs_panel .content.column:last-child {
    width: 40%;
    align-items: flex-start;
  }
  .reddit_content .reddit_url {
    font-size: 1rem;
    font-weight: 600;
    padding: 0 0 15px 0;
  }
  .reddit_content .reddit_description {
    font-size: 0.8rem;
    line-height: 130%;
  }
  .reddit_content .reddit_stats-main {
    border-top: 1px solid hsla(0, 0%, 100%, 0.1);
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
    padding: 20px 0;
    margin: 20px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .reddit_content .reddit_stats-main .title {
    font-weight: 600;
    font-size: 0.9rem;
    padding: 0 0 10px 0;
  }
  .reddit_content .reddit_stats-main .value {
    font-size: 0.8rem;
    position: relative;
    padding: 0 0 0 25px;
  }
  .reddit_stats-main .reddit_stat-karma .value:before {
    background: url('http://yolo.tino.me/wsb_dark/resources/images/reddit/reddit_karma_icon.png')
      center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .reddit_stats-main .reddit_stat-cakeday .value:before {
    background: url('http://yolo.tino.me/wsb_dark/resources/images/reddit/reddit_cakeday_icon.png')
      center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .subtitle {
    font-weight: 600;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 0 0 14px 30px;
  }
  .content.column .subtitle {
    margin: 0 0 14px 0;
    display: flex;
    align-items: center;
  }

  .grid-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content.reddit_stats-global {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-content.stats {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    background: hsla(0, 0%, 100%, 0.05);
    margin: 0 0 0 0;
    padding: 15px;
    border-radius: 10px 0 0 10px;
  }
  .grid-content label {
    padding: 0 0 10px 0;
    line-height: 130%;
    display: flex;
    align-items: center;
  }
  .grid-content.stats label {
    padding: 0;
    line-height: 100%;
    display: flex;
    align-items: flex-start;
  }
  .grid-content label.title {
    text-align: right;
    text-transform: uppercase;
    font-size: 0.8rem;
    justify-content: flex-end;
    max-width: 300px;
  }
  .grid-content.stats label.title {
    text-align: left;
    text-transform: none;
    font-size: 0.8rem;
    justify-content: flex-start;
    max-width: 300px;
    padding: 0 0 5px 0;
  }
  .grid-content label.value {
    margin: 0 0 0 15px;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.stats label.value {
    margin: 0;
    padding: 0 0 15px 0;
    font-weight: 700;
    font-size: 0.8rem;
    justify-content: flex-start;
  }
  .grid-content.stats label.value:last-child {
    padding: 0;
  }
`
const developerCSS = css``

export const OtherUserRedditPanelCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
